export default function authHeader() {
  let token = JSON.parse(localStorage.getItem('adm'))

  if (token) {
    return { Authorization: 'Bearer ' + token }
  } else {
    return {}
  }
}
